import * as React from 'react';
import styles from './MainContent.styl';
import classnames from 'classnames';
class MainContent extends React.PureComponent {
    render() {
        const { children, mainContentClass } = this.props;
        return (React.createElement("div", { className: classnames(styles.content, mainContentClass) }, children));
    }
}
export default MainContent;
